import * as React from 'react';
import { useEffect } from 'react';
import { bookmarksApi } from '../apis/bookmarks';
import { foldersApi } from '../apis/folders';
import { mapFoldersModel } from '../services/shared';
import { FoldersModel } from '../models/foldersModel';
import { useBookmarksContext } from '../context/BookmarksContext';
import { useFolderContext } from '../context/FolderContext';
import { useFoldersContext } from '../context/FoldersContext';
import { useMessageBoxContext } from '../context/MessageBoxContext';
import { useLoadingContext } from '../context/LoadingContext';
import { FoldersListModel } from '../models/foldersListModel';
import { useTokenContext } from '../context/TokenContext';

interface FoldersControlsProps {
  library: string;
}

const FoldersControls: React.FC<FoldersControlsProps> = ({ library }) => { 
  const { Folders, setFolders } = useFoldersContext();
  const { Folder } = useFolderContext();
  const { setMessageBox } = useMessageBoxContext();
  const { Loading, setLoading } = useLoadingContext();
  const { setBookmarks } = useBookmarksContext();
  const { tokenContext } = useTokenContext();

  useEffect(() => {
    if (Loading === false) return;
    if (Folders !== null)  return;

    setLoading(false);
   
    const fetchBookmarks = async () => {
      try {
        const result = await bookmarksApi(library ?? '', tokenContext?.token ?? '');
        setBookmarks(result);
      }
      catch {
        setMessageBox('Bookmark load failure');
      }
    }

    const fetchFolders = async () => {
      try {
        const result = await foldersApi(library ?? '', tokenContext?.token ?? '');
        setFolders(result ?? null);
        }
      catch {
        setMessageBox('Folder load failure');
      }
    };

    setTimeout(() => {
      fetchBookmarks();
      fetchFolders();
    }, 100);
  }, [Loading]);

  useEffect(() => {
    if (Folder) {
      const procura = (item: FoldersModel[] | null, id: number): FoldersModel | null => {
        if (item == null) return null;
        for (let element of item) {
          if (element.Id === id) {
            return element;
          }
          if (element.HasSubFolders) {
            let found = procura(element.SubFolders ?? null, id);
            if (found != null) {
              return found;
            }
          }
        }
        return null;
      };
    }
  }, [Folder]);

  useEffect(() => {
    if (!(Folders === undefined || Folders === null)) {
      setFolders([]);
      let dataLista: FoldersListModel[] = [];
      mapFoldersModel(Folders, '', dataLista);
      setFolders(Folders);
    }
  }, [Folders]);
  
  return (
    <>
    </>
  )
}

export default FoldersControls;